import { render, staticRenderFns } from "./ImportdataPanel.vue?vue&type=template&id=3a9b3a2f&scoped=true"
import script from "./ImportdataPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImportdataPanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ImportdataPanel.vue?vue&type=style&index=0&id=3a9b3a2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9b3a2f",
  null
  
)

export default component.exports